import React from "react";
import AdmTeacherLessonPlan from "../../components/AdminTabs/AdminClassTimeTable/AdmTeacherLessonPlan";

const StudentAttendance = () => {
  return (
    <div>
      <AdmTeacherLessonPlan />
    </div>
  );
};

export default StudentAttendance;
